import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import SvgIcon from './SvgIcon';

class ToolBar extends Component {

    render() {
        const { onAdd, isHideAdd,
            onDelete, isHideDelete, disableDelete,
            onFresh,
            extension } = this.props;

        return (
            <div className="toolBar">
                {(onAdd === undefined || isHideAdd) ? ('') : (
                    <Button onClick={onAdd} title="Add">
                        <SvgIcon name="add" style={{ color: "#5CC96D" }}/>Add
                    </Button>
                )}
                {(onDelete === undefined || isHideDelete) ? ('') : (
                    <Button onClick={onDelete} title="Delete" disabled={disableDelete}>
                        <SvgIcon name="trash_forever" style={{ color: "#FF463B" }}/>Delete
                    </Button>
                )}
                {onFresh === undefined ? ('') : (
                    <Button onClick={onFresh} title="Refresh">
                        <SvgIcon name="refresh" style={{ color: "#5CC96D" }}/>Refresh
                    </Button>
                )}
                {extension}
            </div>
        )
    }
}

export default ToolBar;


// WEBPACK FOOTER //
// ./src/commons/ToolBar.js